import { PortfolioAccountManagerAdminModel } from './portfolio-account-manager-admin-model';
import { Serializable } from '../../../core/models/serializable';

export class PortfolioAccountManagerModel
  implements Serializable<PortfolioAccountManagerModel>
{
  fromObject(object: any): PortfolioAccountManagerModel {
    Object.assign(this, object);

    if (object.admin != null) {
      let t = new PortfolioAccountManagerAdminModel();
      t = t.fromObject(object.admin);
      this.admin = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public portfolioAccountManagerId: number;
  public isCurrent: boolean;
  public startDate: Date;
  public endDate: Date;
  public admin: PortfolioAccountManagerAdminModel;

  constructor() {
    this.admin = new PortfolioAccountManagerAdminModel();
  }
}
